<template>
    <div>
        <div v-if="organizationsLoading"  class="w-100 d-flex justify-content-center align-items-center">
          <a-spin size="large" />
        </div>
        <div v-else>

            
            <div class="d-flex mb-3 justify-content-between">
                <div class="d-flex mb-3">
                <a-card style="width: 240px">
                <a-card-meta :title="organization.name">
                <template slot="description">
                            <p class="mb-0">{{ `${organization.streetname_housenumber} ${organization.zipcode},` }}</p>
                            <p class="mb-0">{{ `${organization.city}` }}</p>
                            <p class="mb-0">{{ organization.coc_number }}</p>
                </template>
                </a-card-meta>
            </a-card>
            <a-card v-if="organization.contact !== null" style="width: 240px" class="ml-4">
                <a-card-meta title="Contactpersoon">
                <template slot="description">
                            <p class="mb-0">{{ `${organization.contact.first_name} ${organization.contact.last_name},` }}</p>
                            <p class="mb-0">{{ `${organization.contact.email}` }}</p>
                            <p class="mb-0">{{ organization.contact.phone_number }}</p>
                </template>
                </a-card-meta>
            </a-card>
            </div>
            <div>
              
              <a-dropdown>
              <a-menu slot="overlay">
                <a-menu-item key="2" @click="openOrganizationDiscountsModal()"> <a-icon type="euro" />Kortingen </a-menu-item>
                <a-menu-item key="3" @click="showDeleteConfirm()" style="background-color: #e74c3c; color: white;"> <a-icon type="delete" />Verwijder Organisatie </a-menu-item>
              </a-menu>
              <a-button style=""><a-icon type="more" /> </a-button>
            </a-dropdown>
            </div>
            </div>
            <div>
            </div>
            <a-tabs default-active-key="1" @change="callback">
              <a-tab-pane key="1" tab="Facturen">
                <h5>Facturen</h5>
                <a-table :columns="InvoiceColumns" :data-source="organization.invoices">
                    <p slot="invoiceCount" class="mb-0" slot-scope="data">{{data.invoice_reservation.length}}</p>
                    <p slot="totalPrice" class="mb-0" slot-scope="data">{{data.invoice_reservation.reduce((a, b) => (parseFloat(a) + parseFloat(b.rate)))}}</p>
                    <a slot="acties" slot-scope="data">
                      <a-button @click="openInvoice(data.id)" class="mr-3" type="primary">
                        Bekijk Factuur
                      </a-button>
                </a>
                </a-table>
              </a-tab-pane>
              <a-tab-pane key="2" tab="Reserveringen" force-render>
                <h5>Reserveringen</h5>
                <a-table :columns="ReserveringColumns" :data-source="organization.reservations">
                    <a slot="acties" slot-scope="data"><a-button @click="openReservation(data.id)" class="mr-3" type="primary">
                    Bekijk
                </a-button>
                <span v-if="data.invoices.length > 0">
                    <a-tag v-for="factuur in data.invoices" color="#108ee9">
                        Factuur #{{factuur.invoice_number}}
                    </a-tag>
                </span>
                </a>
                </a-table>
              </a-tab-pane>
              <a-tab-pane key="3" tab="Gebruikers">
                  <h5>Gebruikers</h5>
                  <a-table :columns="userColumns" :data-source="organization.users">
                      <p slot="name" class="mb-0" slot-scope="data">{{data.first_name}} {{ data.last_name }}</p>
                      <a slot="acties" slot-scope="data">
                        <a-dropdown-button @click="openEditUserModal(data)">
                          <a-icon type="setting" />
                          <a-menu slot="overlay">
                            <a-menu-item key="1" @click="openUserPasswordResetModal(data)"> <a-icon type="mail" />Wachtwoord vergeten email verzenden </a-menu-item>
                          </a-menu>
                        </a-dropdown-button>
                  </a>
                  </a-table>
              </a-tab-pane>
            </a-tabs>
            
            
        </div>
        <a-modal
          title="Gebruiker wijzigen"
          :visible="editUserVisible"
          ok-text="Aanpassen"
          cancel-text="Annuleren"
          @ok="submitEditUser"
          @cancel="cancelEditUser"
        >
          <p class="input-label">Voornaam</p>
          <a-input class="mb-2" v-model="editUser.first_name" placeholder="Voornaam" />
          <p class="input-label">Achternaam</p>
          <a-input class="mb-2" v-model="editUser.last_name" placeholder="Achternaam" />
          <p class="input-label">Email</p>
          <a-input class="mb-2" v-model="editUser.email" placeholder="Email" />
          <p class="input-label">Telefoonnummer</p>
          <a-input class="mb-2" v-model="editUser.phone_number" placeholder="Telefoonnummer" />
          <a-checkbox v-model="editUser.sendPasswordReset">Stuur wachtwoord reset email</a-checkbox>
        </a-modal>
        <a-modal
          title="Stuur gebruiker een wachtwoord reset email"
          :visible="userPasswordResetVisible"
          ok-text="Versturen"
          cancel-text="Annuleren"
          @ok="sendUserPasswordResetEmail"
          @cancel="cancelUserPasswordReset"
        >
          <div class="d-flex align-items-center">
            <a-icon type="exclamation-circle" two-tone-color="#e74c3c" style="color: #e74c3c;font-size: 32px;"/>
            <p class="mb-0 ml-3">Weet je zeker dat je de gebruiker een wachtwoord vergeten email wilt verzenden?</p>
          </div>
        </a-modal>
        <a-modal
          title="Organisatie verwijderen"
          :visible="deleteOrganizationVisible"
          ok-text="Verwijder"
          cancel-text="Annuleren"
          @ok="deleteOrganization"
          :okButtonProps="{style: { display: 'none' }}"
        >
          <div class="d-flex align-items-center">
            <a-icon type="exclamation-circle" two-tone-color="#e74c3c" style="color: #e74c3c;font-size: 32px;"/>
            <p class="mb-0 ml-3">Weet u zeker dat u deze organisatie wilt verwijderen?</p>
          </div>
        </a-modal>
        <a-modal
            id="modal-1"
            title="Organisatie Kortingen"
            v-model="updateOrganizationDiscountsModal"
            :okButtonProps="{props: {class: 'd-none'}}"
            cancel-text="Sluiten"
          >
            <div v-if="organizationDiscountsLoading"  class="w-100 d-flex justify-content-center align-items-center">
              <a-spin size="large" />
            </div>
            <a-table
            v-else
              :columns="discountColumns"
              :dataSource="organizationDiscounts"
              :pagination="false"
              :rowKey='(data, i)=>{return `discountcodediscountsmodal-${i}`}'
            >
              <template slot="service_name" slot-scope="discount">
                <div>
                  <div>{{discount.services ? discount.services.name: 'Prijskorting'}}</div>
                </div>
              </template>
              <template slot="prijs" slot-scope="discount">
                <div>
                  <div>{{discount.discounted_rate !== "" ? '€ ':''}}<s>{{discount.services ? discount.services.rate : ""}}</s> {{discount.discounted_rate}}</div>
                </div>
              </template>
              <template slot="korting_hoeveelheid" slot-scope="discount">
                <div>
                  <div>{{discount.discount_type === 'rate'? `€${discount.discount_amount}`:`${discount.discount_amount}%`}}</div>
                </div>
              </template>
              <template slot="action" slot-scope="discount">
                <div>
                  <button type="button" v-if="discount.isEnabled" @click="toggleOrganizationDiscount(discount.id)" class="btn btn-danger">
                    <i class="fe fe-minus-circle" />
                  </button>
                  <button type="button" v-else @click="toggleOrganizationDiscount(discount.id)" class="btn btn-primary">
                    <i class="fe fe-plus-circle" />
                  </button>
                </div>
              </template>
            </a-table>
          </a-modal>
    </div>
</template>
<script>
const ReserveringColumns = [
  {
    title: 'Voornaam',
    dataIndex: 'first_name',
    key: 'first_name',
  },
  {
    title: 'Achternaam',
    dataIndex: 'last_name',
    key: 'last_name',
  },
  {
    title: 'Kenteken',
    dataIndex: 'license_plate',
    key: 'license_plate',
    ellipsis: true,
  },
  {
    title: 'Prijs',
    dataIndex: 'rate',
    key: 'rate',
    ellipsis: true,
  },
  {
    title: 'Acties',
    scopedSlots: { customRender: 'acties' },
  },
]
const discountColumns = [
  {
    title: 'Korting',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'service_name' },
  },
  {
    title: 'Prijs',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'prijs' },
  },
  {
    title: 'Korting Hoeveelheid',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'korting_hoeveelheid' },
  },
  {
    className: 'bg-transparent text-right',
    scopedSlots: { customRender: 'action' },
  },
]
const InvoiceColumns = [
  {
    title: 'Factuurnummer',
    dataIndex: 'invoice_number',
    key: 'invoice_number',
  },
  {
    title: 'Reserveringsaantal',
    scopedSlots: { customRender: 'invoiceCount' },
  }, //TODO totaal prijs
  {
    title: 'Totaalprijs',
    scopedSlots: { customRender: 'totalPrice' },
  },
  {
    title: 'Acties',
    scopedSlots: { customRender: 'acties' },
  },
]

const userColumns = [
  {
    title: 'Naam',
    scopedSlots: { customRender: 'name' },
  }, //TODO totaal prijs
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
  },
  {
    title: 'Telefoonnummer',
    dataIndex: 'phone_number',
    key: 'phone_number',
  },
  {
    title: 'Acties',
    scopedSlots: { customRender: 'acties' },
  },
]

export default {
  props: ['organizationId'],
  computed: {
    user: {
      get: function () {
        return this.$store.state.user
      },
    },
  },
  data() {
    return {
      organization: undefined,
      organizationsLoading: true,
      ReserveringColumns,
      InvoiceColumns,
      discountColumns,
      userColumns,
      deleteOrganizationVisible: false,
      organizationDiscounts: [],
      updateOrganizationDiscountsModal: false,
      organizationDiscountsLoading: true,
      editUserVisible: false,
      editUser: {},
    }
  },
  mounted() {
    this.getOrganization()
  },
  methods: {
    showDeleteConfirm() {
      this.deleteOrganizationVisible = true;
    },
    openOrganizationDiscountsModal(){
      this.updateOrganizationDiscountsModal = true
      this.getOrganizationDiscounts();
    },
    getOrganizationDiscounts() {
      this.organizationDiscountsLoading = true
      this.$axios.get(`/organization/discounts`, {
        params: {
          organization_id: this.organizationId,
        },
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        } }).then(response => {
        this.organizationDiscountsLoading = false
        this.organizationDiscounts = response.data
      })
    },
    toggleOrganizationDiscount(discount_id) {
      this.$axios.post(`/organization/discounts/toggle`, {
        organization_id: this.organizationId,
        discount_id,
      }, {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        },
      }).then(response => {
        this.getOrganizationDiscounts()
      })
    },
    deleteOrganization(){
        this.$axios.post(`/organization/delete`, {
        organization_id: this.organizationId,
      },
      {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        } }).then(response => {
        this.$router.push({ name: 'organizationList' })
      }).catch(error => {
        console.log(error)
      })
    },
    openReservation(id) {
      this.$router.push({ name: 'singleReservation', params: { reservation_id: id } })
    },
    openInvoice(id) {
      window.open(`https://rp-api.karahan.io/api/test/invoice/show?id=${id}`, "_blank");
    },
    getOrganization() {
      this.organizationsLoading = true
      this.$axios.get('/organization/info', {
        params: {
          organization_id: this.organizationId ? this.organizationId : null,
        },
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        } }).then(response => {
        this.organizationsLoading = false
        this.organization = response.data
      })
    },
    cancelEditUser() {
      this.editUserVisible = false
    },
    openEditUserModal(user) {
      this.editUser = user
      this.editUserVisible = true
    },
    submitEditUser() {
      this.$axios.post(`/organization/user/edit`, {
        user_id: this.editUser.id,
        first_name: this.editUser.first_name,
        last_name: this.editUser.last_name,
        email: this.editUser.email,
        phone_number: this.editUser.phone_number,
      }, {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        },
      }).then(response => {
        this.getOrganization();
        this.editUserVisible = false
        if(this.editUser.sendPasswordReset){
          this.sendUserPasswordResetEmail()
        }else{
          this.editUser = {}
        }
      })
    },
    openUserPasswordResetModal(user) {
      this.userPasswordResetVisible = true
      this.editUser = user
    },
    sendUserPasswordResetEmail() {
      this.$axios.post(`/organization/user/password-reset`, {
        user_id: this.editUser.id,
      }, {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        },
      }).then(response => {
        this.userPasswordResetVisible = false
        this.editUser = {}
      })
    },
    cancelUserPasswordReset() {
      this.userPasswordResetVisible = false
      this.editUser = {}
    },
  },
}
</script>
